const quizData = [
  {
    id: "dd4f7738-f811-4bd1-bb2b-f6913f28c92a",
    title: "F.R.I.E.N.D.S",
    category: "Easy",
    assets: {
      imgUrl: "https://cdn.wallpapersafari.com/48/64/tQNYrD.jpg",
      alt: "friends",
    },
    content:
      "Six friends, ten seasons, and seventeen years of reruns since our favorite series finished. Let’s see how much of a fanatic you truly are",
    questions: [
      {
        id: 1,
        question: "Which Stephen King book did Joey hide in his freezer?",
        answer: "The Shining",
        options: ["Pet Sematary", "The Shining", "Carrie", "it"],
      },
      {
        id: 2,
        question: "What is Ross’ profession?",
        answer: "Museum tour guide",
        options: [
          "Geologist",
          "Astronomer",
          "Palaeontologist",
          "Museum tour guide",
        ],
      },
      {
        id: 3,
        question: "What is Chandler’s middle name?",
        answer: "Muriel",
        options: ["Muriel", "Nora", "Charles", "Francis"],
      },
      {
        id: 4,
        question: "What is Dumbledore’s patronus?",
        answer: "Phoenix",
        options: ["A small dog", "Phoenix", "Rabbit", "A dinosour"],
      },
      {
        id: 5,
        question:
          "How many pages were in the letter Rachel wrote to Ross (front and back!)?",
        answer: "18",
        options: ["12", "8", "3", "18"],
      },
    ],
  },
  {
    id: "e6013566-767d-404b-b099-b869f213e4cc",
    title: "RRR",
    category: "Medium",
    assets: {
      imgUrl:
        "https://timesofindia.indiatimes.com/thumb/msid-90295739,width-1200,height-900,resizemode-4/.jpg",
      alt: "RRR",
    },
    content:
      "Can you answer all the questions about Ram Charan-Jr NTR’s blockbuster movie?",
    questions: [
      {
        id: 1,
        question:
          "RRR is a fictional story about which two Indian revolutionaries?",
        answer: "Alluri Sitarama Raju and Komaram Bheem",
        options: [
          "Alluri Sitarama Raju and Komaram Bheem",
          "Subramania Bharati and Tiruppur Kumaran",
          "Velu Nachiyar and Vanchinathan",
          "Veerapandiya Kattabomman and Dheeran Chinnamalai",
        ],
      },
      {
        id: 2,
        question: "RRR’s first song Dosti released on which special day?",
        answer: "Friendship Day",
        options: [
          "Valentine’s Day",
          "Friendship Day",
          "Independence Day",
          "Republic Day",
        ],
      },
      {
        id: 3,
        question:
          "S.S. Rajamouli took inspiration from which movie for his magnum opus RRR?",
        answer: "The Motorcycle Diaries",
        options: [
          "Why We Ride",
          "Long Way Round",
          "The Motorcycle Diaries",
          "The Great Escape",
        ],
      },
      {
        id: 4,
        question: " Who is the writer of RRR?",
        answer: "K.V. Vijayendra Prasad",
        options: [
          "K.V. Vijayendra Prasad",
          "K Raghavendra Rao",
          "Kona Venkat",
          "Vakkantham Vamsi",
        ],
      },
      {
        id: 5,
        question: "Where was the song ‘Naatu Naatu’ shot?",
        answer: "Ukraine",
        options: ["India", "Ukraine", "Germany", "France"],
      },
    ],
  },
  {
    id: "w3903577-767d-404b-y777-b869f213e4dd",
    title: "Stranger Things",
    category: "Difficult",
    assets: {
      imgUrl: "https://wallpapercave.com/wp/wp11155470.jpg",
      alt: "money-professor",
    },
    content:
      "Can You Match All 5 Of These 'Stranger Things' 4 Quotes To The Characters Who Said Them?",
    questions: [
      {
        id: 1,
        question: "I think it's finally my year.",
        answer: "Eddie",
        options: ["Dustin", "Eddie", "Lucas", "Jason"],
      },
      {
        id: 2,
        question: "Are you real? Did I make you?",
        answer: "Max",
        options: ["Mike", "El", "Eddie", "Max"],
      },
      {
        id: 3,
        question: "Don't try to be cute or be a hero or something",
        answer: "Steve",
        options: ["Steve", "Jonathan", "Nancy", "Robin"],
      },
      {
        id: 4,
        question:
          "My fingers are like arrows. My arms like iron. My feet like spears. Resist and I’ll end you",
        answer: "Murray",
        options: ["Steve", "Eddie", "Yuri", "Murray"],
      },
      {
        id: 5,
        question: "You’re the heart. Okay? Remember that.",
        answer: "Will",
        options: ["Robin", "Mike", "Will", "Hopper"],
      },
    ],
  },
];

export { quizData };
